import { gql } from '../../__generated__/gql'

export const SIGN_UP_GIFT_SUBSCRIPTION_MUTATION = gql(`
  mutation signUpGiftSubscription(
    $firstName: String!
    $lastName: String!
    $email: String!
    $password: String!
    $organization: String!
    $giftSubToken: String!
  ) {
    signUpGiftSubscription(
      input: {
        firstName: $firstName
        lastName: $lastName
        email: $email
        password: $password
        organization: $organization
        giftSubToken: $giftSubToken
      }
    ) {
      user {
        ...userProfileFields
      }
    }
  }
`)
